import { Component } from '@angular/core';

@Component({
  selector: 'app-admission-procedure',
  templateUrl: './admission-procedure.component.html',
  styleUrls: ['./admission-procedure.component.scss']
})
export class AdmissionProcedureComponent {

}
